export enum FormMode {
  FormPreview = 'form_preview',
  Submittable = 'submittable',
  PatientSubmittable = 'patient_submittable',
  ReadOnly = 'read_only',
  PatientReadOnly = 'patient_read_only',
}
